import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import declint from 'utils/declint';

// Components
import { DataBlocks } from 'components';
import { Text } from '@beef/ui-kit';
import { FamilyBeelineModal } from './components/FamilyBeelineModal';
import { NumberListFamily } from './components/NumberListFamily';
import { ButtonBlock } from './components/ButtonBlock';
import { HeaderFamily } from './components/HeaderFamily';
import { BannerFamily } from './components/BannerFamily';

// Actions
import { fetchFamilyData } from '../../actions';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const FamilyWithBeeline = () => {
  const [isPopupOpen, setPopupState] = useState(false);
  const dispatch = useDispatch();
  const { personalInfo, info, isLoading } = useSelector((state) => state.home.personalFamily);

  useEffect(/* async */ () => {
    dispatch(fetchFamilyData());
  }, []);

  const hasInvites = useMemo(() => !!info?.invites?.length, [info]);

  const isMaximumInvited = useMemo(() => info?.count !== info?.invites?.length, [info]);

  const invitationCountText = useMemo(() => {
    if (typeof personalInfo?.inviteDescription === 'string') {
      const invitesLength = info?.invites?.length;

      const declensionedText = declint(
        invitesLength,
        ['номером', 'номерами', 'номерами'],
      );

      let replacedText = personalInfo.inviteDescription.replace('{{COUNT}}', invitesLength)
        .replace('{{MAXCOUNT}}', info?.count).replace('{{NUMERIC}}', declensionedText);

      if (invitesLength === info?.count) {
        replacedText = `${replacedText} ${personalInfo.inviteAdditionalText}`;
      }
      return replacedText;
    }
  }, [info, personalInfo]);

  // TODO уберу в компонент-родитель при реалиации STAGE 3
  // так как на данный момент компонент не будет отображаться в Прод
  if (!personalInfo || !info || isLoading) return null;

  return (
    <DataBlocks.Block className={cn('wrapper')}>
      {!hasInvites && (
        <BannerFamily
          info={personalInfo}
          isSeb={info?.isSeb}
        >
          <ButtonBlock
            setPopupState={setPopupState}
            addButtonText={personalInfo?.addNumberButtonText}
            aboutButtonText={personalInfo?.aboutFamily}
            isMaximumInvited={isMaximumInvited}
          />
        </BannerFamily>
      )}
      {hasInvites && (
        <>
          <HeaderFamily
            title={personalInfo?.title}
            price={info?.price}
            unit={info?.unit}
            discount={info?.discount}
          />
          <div className={cn('description')}>
            <Text
              color="grey50"
              size="size5-r-s"
            >
              {invitationCountText}
            </Text>
          </div>
          {hasInvites && (
            <NumberListFamily
              numberList={info?.invites}
            />
          )}
          <ButtonBlock
            setPopupState={setPopupState}
            addButtonText={personalInfo?.addNumberButtonText}
            aboutButtonText={personalInfo?.aboutFamily}
            isMaximumInvited={isMaximumInvited}
          />
        </>
      )}
      <FamilyBeelineModal
        isPopupOpen={isPopupOpen}
        setPopupState={setPopupState}
        popupContent={personalInfo?.popupContent}
        invitedNumbers={info?.invites}
      />
    </DataBlocks.Block>
  );
};

export { FamilyWithBeeline };
